/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import send from '../utils/fetch'
import axios from 'axios'
const actions = {
    addRequest({ commit }, data) {
        commit('AJAX_REQUEST', data)
    },

    async fetch ({ commit }, income) {
        try {
            const {data} = await send(income.url, 'GET')
            if (income.mutation) commit(income.mutation, {data, income})
            return data
        } catch (e) {
            return Promise.reject(e)
        }
    },

    async fetchId ({ commit }, income) {
        try {
            const {data} = await send(`${income.url}?id=${income.id}`, 'GET')
            if (income.mutation) commit(income.mutation, {data, income})
            return data
        } catch (e) {
            return Promise.reject(e)
        }
    },

    async create ({ commit }, income) {
        try {
            const {data} = await send(income.url, 'POST', {data: income.data})
            if (income.mutation) commit(income.mutation, {data, income})
            return data
        } catch (e) {
            return Promise.reject(e)
        }
    },

    async edit ({ commit }, income) {
        try {
            const {data} = await send(income.url, 'PUT', {data: income.data})
            if (income.mutation) commit(income.mutation, {data, income})
            return data
        } catch (e) {
            return Promise.reject(e)
        }
    },

    async destroy ({ commit }, income) {
        try {
            const {data} = await send(income.url, 'DELETE', {data: income.data})
            if (income.mutation) commit(income.mutation, {data, income})
            return data
        } catch (e) {
            return Promise.reject(e)
        }
    },

    //USERS
    async ADD_TRACKER({ commit }, data) {
      try {
        const response = await send('/user/tracker/create', 'POST', { data })
        return response.data
      } catch (e) {
        return Promise.reject(e)
      }
    },


    // /////////////////////////////////////////////
    // COMPONENTS
    // /////////////////////////////////////////////

    // Vertical NavMenu
    updateVerticalNavMenuWidth({ commit }, width) {
      commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width)
    },

    // VxAutoSuggest
    updateStarredPage({ commit }, payload) {
      commit('UPDATE_STARRED_PAGE', payload)
    },

    // The Navbar
    arrangeStarredPagesLimited({ commit }, list) {
      commit('ARRANGE_STARRED_PAGES_LIMITED', list)
    },
    arrangeStarredPagesMore({ commit }, list) {
      commit('ARRANGE_STARRED_PAGES_MORE', list)
    },

    // /////////////////////////////////////////////
    // UI
    // /////////////////////////////////////////////

    toggleContentOverlay({ commit }) {
      commit('TOGGLE_CONTENT_OVERLAY')
    },
    updateTheme({ commit }, val) {
      commit('UPDATE_THEME', val)
    },

    // /////////////////////////////////////////////
    // User/Account
    // /////////////////////////////////////////////

    updateUserInfo ({ commit }, payload) {
      commit('UPDATE_USER_INFO', payload)
    },

    setUserPermissions({commit}, permissions) {
        commit('SET_USER_PERMISSIONS', permissions)
    },

    setSystemSettings({commit}, settings) {
        commit('SET_SYSTEM_SETTINGS', settings)
    },

    setUserInfo ({ commit }, payload) {
        commit('SET_USER_INFO', payload)
    },
    // editUsasder ({ commit }, payload) {
    //     return new Promise((resolve, reject) => {
    //         axios.get('/params/user')
    //             .then((response) => {
    //                 const teams = response.data.teams
    //                 Object.keys(teams).map(vals => {
    //                     Object.keys(teams[vals].users).map(val => {
    //                         if (teams[vals].users[val].hash === payload) {
    //                             commit('EDIT_USER', teams[vals].users[val])
    //                             resolve(val)
    //                         }
    //                     })
    //                 })
    //             })
    //             .catch((error) => { reject(error) })
    //         // const users = this.state.userManagement.users
    //         // Object.keys(users).map(val => {
    //         //     if (users[val].hash === payload) {
    //         //         commit('EDIT_USER', users[val])
    //         //         resolve(val)
    //         //     } else {
    //         //         reject(val)
    //         //     }
    //         // })
    //     })
    // },
    // editUser ({ commit }, payload) {
    //     return new Promise((resolve, reject) => {
    //
    //     })
    // }
}

export default actions
